// Web Push subscription utilities
import { api } from '@/lib/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getCurrentSubscription() {
  if (!(await isPushSupported())) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function subscribePush() {
  if (!(await isPushSupported())) throw new Error('Push no soportado en este navegador');

  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permiso denegado por el navegador');

  const reg = await navigator.serviceWorker.ready;
  const { data: keyData } = await api.get('/push/public-key');
  const publicKey = keyData.public_key;
  if (!publicKey) throw new Error('VAPID public key no configurada en el servidor');

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    try {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    } catch (e) {
      const name = e?.name || '';
      if (name === 'NotAllowedError') throw new Error('Permiso de notificaciones denegado');
      if (name === 'NotSupportedError') throw new Error('Push no soportado en este navegador (¿modo incógnito?)');
      if (name === 'AbortError') throw new Error('No se pudo conectar al servicio de push del sistema');
      throw new Error(e?.message || 'Error al suscribirse al push');
    }
  }
  await api.post('/push/subscribe', {
    subscription: sub.toJSON(),
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  try { await api.post('/push/unsubscribe', { endpoint: sub.endpoint }); } catch {}
  await sub.unsubscribe();
}

export async function sendTestPush() {
  return api.post('/push/test');
}
